import { render } from "./Event.vue?vue&type=template&id=16a9e1fc"
import script from "./Event.vue?vue&type=script&lang=js"
export * from "./Event.vue?vue&type=script&lang=js"

import "./Event.vue?vue&type=style&index=0&id=16a9e1fc&lang=css"
script.render = render

export default script